import React from 'react';
import Editor, { EditorProps, useMonaco } from '@monaco-editor/react';
import { useTheme } from '@mui/material/styles';

interface IElyxMonacoEditorProps extends EditorProps {
	// Add any custom Elyx props here later
}

const ElyxMonacoEditor: React.FC<IElyxMonacoEditorProps> = (props) => {
	const muiTheme = useTheme();
	const monaco = useMonaco();

	// In the future, we can sync the MUI theme with Monaco's theme here.
	// For now, we'll just use the default vs-dark or vs-light.
	const editorTheme = muiTheme.palette.mode === 'dark' ? 'vs-dark' : 'vs';

	return (
		<Editor
			theme={editorTheme}
			options={{
				minimap: { enabled: false },
				scrollBeyondLastLine: false,
				wordWrap: 'on',
				lineNumbers: 'on',
				folding: false,
				glyphMargin: false,
				lineDecorationsWidth: 10,
				lineNumbersMinChars: 3,
				fontFamily: '"Fira Code", "JetBrains Mono", monospace',
				fontSize: 14,
				...props.options,
			}}
			{...props}
		/>
	);
};

export default ElyxMonacoEditor;
